import {FormControlLabel, Radio, RadioGroup, styled, Typography} from "@mui/material";
import TableStyleIcon from "assets/icons/invoice/TableStyleIcon";
import {useFormikContext} from "formik";
import fillImg from "assets/table/fill.png";
import linearImg from "assets/table/linear.png";
import mixedImg from "assets/table/mixed.png";

const FactorTableSettingContainer = styled("div")(({theme}) => ({
    margin: "40px 16px 16px 16px",
}));
const HeaderComponent = styled("div")(({theme}) => ({
    padding: "16px",
    height: "40px",
    backgroundColor: "#F3F4F5",
    display: "flex",
    borderRadius: "4px 4px 0 0",
    alignItems: "center",
}));
const TableSelectContainer = styled("div")(({theme}) => ({
    padding: "16px",
    paddingTop: "40px",
    display: "flex",
    flexDirection: "column",
}));
const TableImage = styled("img")(({theme}) => ({
    width: "150px",
    height: "auto",
}));

const StyledFormControlLabel = styled(FormControlLabel)(({theme}) => ({
    marginBottom: "20px",
}));

// const TableImage = ({ src }: { src: string }) => {
//   return (
//     <TableImageComponent src={src} />
//   )
// }

const FactorTableSetting = () => {
    const formikContext = useFormikContext();

    const {values} = formikContext as any;

    return (
        <FactorTableSettingContainer>
            <HeaderComponent>
                <TableStyleIcon/>
                <Typography variant="body2" sx={{marginRight: "10px"}}>
                    انتخاب استایل جدول
                </Typography>
            </HeaderComponent>
            <TableSelectContainer>
                <RadioGroup
                    name="tableStyle"
                    onChange={(event) => formikContext.setFieldValue("tableStyle", event.currentTarget.value)}
                    value={values?.tableStyle}
                >
                    <StyledFormControlLabel value="fill" control={<Radio/>} label={<TableImage src={fillImg}/>}/>
                    <StyledFormControlLabel value="linear" control={<Radio/>} label={<TableImage src={linearImg}/>}/>
                    <StyledFormControlLabel value="mixed" control={<Radio/>} label={<TableImage src={mixedImg}/>}/>
                </RadioGroup>
            </TableSelectContainer>
        </FactorTableSettingContainer>
    );
};

export default FactorTableSetting;
